import React from "react";
import styles from "./HeroSection.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import homepageHero1 from "../../../assets/images/homepage-hero1.jpg";
import homepageHero2 from "../../../assets/images/homepage-hero2.jpg";
import homepageHero3 from "../../../assets/images/homepage-hero3.jpg";

const HeroSection = () => {
  return (
    <div className={styles.homepageHeroSection}>
      <Swiper
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        className="homepageHeroSwiper"
      >
        <SwiperSlide>
          <div className={styles.heroSectionContainer}>
            <div className={styles.heroLeft}>
              <div>
                <h1>What is Lorem Ipsum?</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </p>
                <button>Read More</button>
              </div>
            </div>
            <div className={styles.heroRight}>
              <img src={homepageHero1} alt="Hero1" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.heroSectionContainer}>
            <div className={styles.heroLeft}>
              <div>
                <h1>What is Lorem Ipsum?</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </p>
                <button>Read More</button>
              </div>
            </div>
            <div className={styles.heroRight}>
              <img src={homepageHero2} alt="Hero2" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.heroSectionContainer}>
            <div className={styles.heroLeft}>
              <div>
                <h1>What is Lorem Ipsum?</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </p>
                <button>Read More</button>
              </div>
            </div>
            <div className={styles.heroRight}>
              <img src={homepageHero3} alt="Hero3" />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default HeroSection;
